import { Capacitor, registerPlugin } from '@capacitor/core';

const ThemeIcon = registerPlugin('ThemeIcon');

/** Pure and custom both use AppIconPure on iOS; native getCurrentIcon reports "pure" for that asset. */
const sameIosIconTheme = (a, b) =>
  a === b ||
  (a === 'custom' && b === 'pure') ||
  (a === 'pure' && b === 'custom');

export const applyThemeIcon = async (theme) => {
  const isIOSNative = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  if (!isIOSNative) return;

  try {
    const current = await ThemeIcon.getCurrentIcon();
    if (sameIosIconTheme(current?.theme, theme)) {
      return;
    }

    await ThemeIcon.setThemeIcon({ theme });
  } catch (error) {
    console.warn('Failed to update app icon for theme:', error);
  }
};
